import { createRoot } from "react-dom/client";
import { DOMAttributes } from "react";
import App from "./App";

import {
  Additions,
  Massmask,
  ProductionInstruction,
} from "@medi-mtm/components";
import { LicenseInfo } from "@mui/x-license";
import { ServiceContextProvider } from "shared/provider/service_provider";
import { AuthContextProvider } from "shared/provider/auth_provider";
import { I18nProvider } from "shared/provider/i18n_provider";
import DefaultBffGuard from "shared/guards/defaultbff.guard";
import { UserRole } from "./authentication/userrole";

LicenseInfo.setLicenseKey(
  "4622054fe572e36d0f04c21de5612a00Tz0xMjQ2MDEsRT0xODAyNjQ5NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=",
);

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <ServiceContextProvider>
    <AuthContextProvider
      path={`${window.location.pathname}${window.location.search ?? ""}`}
    >
      <I18nProvider>
        <DefaultBffGuard requiredRole={UserRole.MceViewer}>
          <App />
        </DefaultBffGuard>
      </I18nProvider>
    </AuthContextProvider>
  </ServiceContextProvider>,
);

type CustomEvents<K extends string> = {
  [key in K]: (event: CustomEvent) => void;
};
// eslint-disable-next-line
type CustomElement<T, K extends string> = Partial<
  T & DOMAttributes<T> & { children: any } & CustomEvents<`on${K}`>
> & {
  // eslint-disable-next-line
  ref?: any;
  // eslint-disable-next-line
  key?: any;
};

declare global {
  namespace React.JSX {
    interface IntrinsicElements {
      ["x-massmask"]: CustomElement<Massmask, "">;
      ["x-additions"]: CustomElement<Additions, "">;
      ["x-productioninstruction"]: CustomElement<ProductionInstruction, "">;
    }
  }
}
